export default __webpack_public_path__ + "static/Plots0077-e2576f93db1852ef0c910785b23d3519.jpg";